import { mergeStyleSets } from '@uifabric/merge-styles';
import theme, { layout } from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  spinner: {
    marginTop: 40,
  },
  errorContainer: {
    margin: 'auto',
    textAlign: 'center',
  },
  errorMessage: {
    color: theme.palette.accentError,
  },
  tabs: {
    marginBottom: pxToRem(26),
    selectors: {
      [layout.breakpoints.min.md]: {
        marginBottom: '2rem',
      },
      [layout.breakpoints.min.lg]: {
        marginBottom: pxToRem(40),
      },
    },
  },
  statementPeriod: {
    fontWeight: `normal !important`,
    color: `${theme.palette.neutralSecondary} !important`,
  },
  slash: {
    color: theme.palette.neutralQuaternaryAlt,
  },
  breadcrumbs: {
    fontSize: pxToRem(22),
    fontWeight: 600,
  },
  contractInfo: {
    color: `${theme.palette.neutralDark} !important`,
    selectors: {
      [layout.breakpoints.min.md]: {
        textAlign: 'right',
      },
    },
  },
  meta: {
    padding: '.5rem 0 1.5rem',
  },
  metaChild: {
    selectors: {
      [layout.breakpoints.min.md]: {
        alignSelf: 'flex-end',
      },
    },
  },
  value: {
    fontWeight: 600,
    color: theme.palette.neutralDark,
  },
  frequency: {
    paddingLeft: `${pxToRem(0)} !important`,
    paddingTop: `${pxToRem(8)} !important`,
    marginBottom: `${pxToRem(0)} !important`,
  },
  paymentModule: {
    boxShadow: 'none',
    paddingTop: pxToRem(40),
  },
  card: {
    width: '100%',
    height: pxToRem(72),
    backgroundColor: theme.palette.neutralLighterAlt,
    display: 'inline-grid',
    paddingTop: pxToRem(8),
    paddingBottom: pxToRem(12),
    paddingLeft: pxToRem(24),
    selectors: {
      [layout.breakpoints.min.md]: {
        maxWidth: pxToRem(356),
      },
    },
  },
  rightCard: {
    selectors: {
      [layout.breakpoints.min.md]: {
        float: 'right',
      },
    },
  },
  bottomText: {
    paddingTop: pxToRem(2),
    fontSize: pxToRem(16),
    selectors: {
      [layout.breakpoints.min.lg]: {
        fontSize: pxToRem(22),
      },
    },
  },
  topText: {
    height: pxToRem(20),
    fontSize: pxToRem(12),
    marginRight: pxToRem(28),
  },
  paymentStatusSentIcon: {
    paddingTop: pxToRem(100),
    marginRight: pxToRem(10),
    color: theme.palette.accentTeal,
  },
  paymentStatusInProgressIcon: {
    paddingTop: pxToRem(50),
    marginRight: pxToRem(10),
    color: theme.palette.accentYellow,
  },
  paymentStatusDate: {
    fontSize: pxToRem(16),
    fontWeight: `300 !important`,
    color: `${theme.palette.neutralSecondary} !important`,
    marginRight: pxToRem(10),
    selectors: {
      [layout.breakpoints.min.lg]: {
        fontSize: pxToRem(22),
      },
    },
  },
  details: {
    color: theme.palette.neutralSecondary,
    fontSize: pxToRem(10),
  },
  toolTipHost: {
    display: 'inline-block',
    verticalAlign: 'middle',
    selectors: {
      '& .ms-Button:hover': {
        backgroundColor: 'transparent',
        color: `${theme.palette.themePrimary} !important`,
      },
    },
  },
  callout: {
    gapSpace: 0,
    calloutWidth: pxToRem(214),
    backgroundColor: theme.palette.neutralWhite,
    minPagePadding: pxToRem(16),
  },
  tooltip: {
    styles: {
      root: { backgroundColor: theme.palette.neutralWhite, padding: 0 },
      subText: {
        backgroundColor: theme.palette.neutralWhite,
        fontSize: pxToRem(12),
        padding: pxToRem(16),
      },
    },
  },
  infoText: {
    paddingTop: pxToRem(8),
    fontWeight: 'normal',
  },
  link: {
    textDecoration: 'none',
  },
  footerText: {
    paddingTop: pxToRem(8),
    paddingBottom: pxToRem(8),
    textAlign: 'right',
  },
  infoIcon: {
    position: 'relative',
    marginRight: pxToRem(6),
    color: theme.palette.neutralTertiary,
    verticalAlign: 'middle',
    padding: `${pxToRem(9)} 0 ${pxToRem(7)} ${pxToRem(26)}`,
    fontSize: pxToRem(16),
  },
  percapInfoIcon: {
    position: 'relative',
    marginLeft: pxToRem(6),
    color: theme.palette.themePrimary,
    verticalAlign: 'middle',
    fontSize: pxToRem(16),
  },
  statementActivity: {
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralLight}`,
  },
  percapText: {
    fontWeight: 'normal',
    padding: `0 ${pxToRem(25)} ${pxToRem(25)} ${pxToRem(25)}`,
  },
  statementSummaryContainer: {
    paddingLeft: '1.5rem',
    paddingRight: '1.5rem',
    paddingBottom: '1.5rem',
  },
});
